import ClaimGuest from '@website/components/guests/ClaimGuest';
import ClaimGuestLogin from '@website/components/guests/ClaimGuestLogin';
import LoadingPage from '@website/components/utilities/LoadingPage';
import { Store } from '@website/Store';
import { useContext } from 'react';
import { Container } from 'react-bootstrap';

export function ClaimGuestPageInner() {
  const { state } = useContext(Store);

  if (state.isAuthenticated) {
    return <ClaimGuest />;
  }

  if (state.isAuthenticating) {
    return <LoadingPage />;
  }

  return <ClaimGuestLogin />;
}

export default function ClaimGuestPage() {
  return (
    <Container className="p-5">
      <ClaimGuestPageInner />
    </Container>
  );
}
